module.exports = __webpack_public_path__ + "img/38400.4f2c98f9.jpg";